import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
    selector: 'app-agreement',
    templateUrl: './agreement.component.html',
    styleUrls: ['./agreement.component.css']
})
export class AgreementComponent implements OnInit {

    public salesPeople: any = [];
    public salesPeopleForm: FormGroup = this.formBuilder.group({
        select: ['']
    });

    @Input() staticLink: boolean = false;
    @Output() salesPersonSelected = new EventEmitter<number>();

    constructor(
        private connectionService: ConnectionService,
        private route: ActivatedRoute,
        private formBuilder: FormBuilder
    ) { }

    ngOnInit() {
        if (this.staticLink) {
            this.getSalesPeople().then(
                (data: any) => this.salesPeople = data.object
            );
        }
    }

    getSalesPeople() {
        const token = this.route.snapshot.queryParams.token;
        const user = this.route.snapshot.queryParams.user;
        const promise = new Promise((resolve, reject) => {
            this.connectionService.getRequestWithToken(environment.gateway + 'vendor/sales/' + user, 'application/json', token).subscribe(
                (data: any) => {
                    resolve(data);
                },
                (error: any) => {
                    reject(error);
                }
            );
        });
        return promise;
    }

    salesPersonChanged() {
        this.salesPersonSelected.emit(this.salesPeopleForm.controls.select.value);
    }

}
